import { useContext, useEffect, useState } from "react";
import { useParams, Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Container, Card, Button, Row, Col, Image } from "react-bootstrap";
import { DarshanBook_TempleList } from "../../ApiServices/Darshan Booking/DarshanBookingApi";
import LoginPopUp from "../LoginPopup";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import { Helmet } from "react-helmet-async";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { GetFAQListByService } from "../../ApiServices/FAQ/FAQApi";
import { FaqModuleID } from "../enum";

import pandit from "../../assets/images/new/fav-removebg-preview.png";
import ShareLinkModal from "../ShareLinkModal";
import { DarshanShareMassage } from "../../middlewares/Utils";
import { GetTempleDarshanDetailBySlug } from "../../ApiServices/Temple Darshan Booking/TempleDarshanBookingApi";


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PujaPageSections from "../../Pages/RemedyPuja/PujaTabs";
import HowItWorks from "../CommonSections/HowItWorks";
import DownloadApp from "../DownLoadApp/DownloadApp";
import LazySection from "../../Pages/Home/LazySection";
import { t } from "i18next";
import { faStar, faCalendarAlt, faChevronLeft, faChevronRight, faVihara, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faShareAlt } from "@fortawesome/free-solid-svg-icons"; // or faShareNodes if you prefer newer icon
import NoResultFoundModel from "../NoDataFound/NoDataFoundModal";
import DarshanBookingDetailedTabSection from "./DarshanBookingDetailedTabSection";

const TempleDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Get templeDarshanDetails ID from URL
  const [loginPopUp, setLoginPopUp] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const currentUrl = window.location.href;

  const { setLoader, selectedLanguageID } = useContext(LoaderContext);
  const [templeDarshanDetails, setTempleDarshanDetails] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const { isAuthenticated } = useContext(AuthContextProvider);
  const { slug } = useParams();
  const [FAQ, setFaq] = useState([]);
  const location = useLocation()

  const [totalRecords, setTotalRecords] = useState(-1);
  const [readMore, setReadMore] = useState(false);
  const [deityReadMore, setDeityReadMore] = useState(false);
  const [readMoreDetailed, setReadMoreDetailed] = useState(false);
  const maxChars = 500; // number of characters to show initially
  const DeityChars = 80; // number of characters to show initially


  const [modelRequestData, setModelRequestData] = useState({
    Action: null,
    DARSHAN_PRICE: null,
    DARSHAN_TIME: null,
    TR_ID: null,
    CONVENIENCE_FEE: null,
    TR_SHORTDETAILS: null,
  });

  useEffect(() => {
    fetchTempleDetails();
  }, [location]);

  const fetchTempleDetails = async () => {
    const userID = localStorage.getItem("userID") || "";
    setLoader(true);

    try {
      const response = await GetTempleDarshanDetailBySlug(selectedLanguageID, slug);

      // ✅ New response structure
      if (response?.statusCode === 200 && response?.responseData?.data?.length > 0) {
        setLoader(false);

        const templeData = response.responseData.data[0]; // get first item
        setTempleDarshanDetails(templeData); // ✅ Update state with new data
        GetFAQListByServiceData(templeData?.templeDarshanID); // ✅ Updated key name
        setTotalRecords(templeData ? 1 : 0); // Update totalRecords based on data presence
      } else {
        setLoader(false);
        setTotalRecords(0); // Update totalRecords based on data presence
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching templeDarshanDetails details:", error);
    }
  };


  const GetFAQListByServiceData = async (PujaID) => {

    setLoader(true);
    try {
      const response = await GetFAQListByService(
        FaqModuleID?.DarshanBooking,
        PujaID
      );

      if (response) {
        setLoader(false);
        const modalData = response.DATA;

        setFaq(modalData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (loading) {
    return <div className="text-center mt-5">Loading templeDarshanDetails details...</div>;
  }

  if (!templeDarshanDetails) {
    return <div className="text-center mt-5">Temple not found.</div>;
  }

  const clickToBook = () => {


    {
      setModelRequestData({
        ...modelRequestData,
        Action: null,
        canonicalTag: templeDarshanDetails.canonicalTag,
        convenienceFee: templeDarshanDetails.convenienceFee,
        convinienceFeeTaxAmount: templeDarshanDetails.convinienceFeeTaxAmount,
        convinienceFeeTaxPercent: templeDarshanDetails.convinienceFeeTaxPercent,

        darshanPrice: templeDarshanDetails.darshanPrice,
        extraMetaTag: templeDarshanDetails.extraMetaTag,
        keyFeature: templeDarshanDetails.keyFeature,
        metaDescription: templeDarshanDetails.metaDescription,
        metaTitle: templeDarshanDetails.metaTitle,
        openGraphTag: templeDarshanDetails.openGraphTag,
        shortDescription: templeDarshanDetails.shortDescription,
        shortDescription: templeDarshanDetails.shortDescription,

        templeAddress: templeDarshanDetails.templeAddress,
        templeDarshanDetails: templeDarshanDetails.templeDarshanDetails,
        templeDarshanID: templeDarshanDetails.templeDarshanID,
        templeDarshanName: templeDarshanDetails.templeDarshanName,
        templeDarshanRules: templeDarshanDetails.templeDarshanRules,
        templeID: templeDarshanDetails.templeID,
        templeName: templeDarshanDetails.templeName,
        templeSlug: templeDarshanDetails.templeSlug,
      });
    }

    if (isAuthenticated) {
      navigate("/temple-booking-form", { state: templeDarshanDetails });
    } else {
      setLoginPopUp(true);
    }
  };
  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount?.toString()?.split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }
  const FaqObj = [
    {
      question: "What services does Myomnamo offer?",
      answer:
        "Myomnamo offers a range of spiritual services, including Puja and Darshan bookings. You can book experienced Pandits for rituals or arrange daily pujas. Our E-Store provides access to religious goods, and Puja samgari, puja kits. Additionally, Myom namo offers horoscope services.",
      color: "#ffa415",
    },
    {
      question: "Can I schedule a templeDarshanDetails visit through My OmNamo?",
      answer:
        "Yes, Myomnamo allows you to book templeDarshanDetails visits online for your convenience. You can easily select your preferred templeDarshanDetails, date, and time through our app. My Om Namo specializes in offering customized puja packages and online Darshans.",
      color: "#fc5528",
    },
    {
      question: "Can I book personalized consultations with spiritual mentors?",
      answer:
        "Yes, Myomnamo provides a platform to book personalized consultations with experienced spiritual mentors. You can connect with mentors who can offer guidance and support on your spiritual journey. These sessions can provide personalized advice and practices tailored to your specific needs",
      color: "#8139e7",
    },
    // {
    //   question: "Why is it important How Volunteer?",
    //   answer:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": templeDarshanDetails?.metaTitle,
    "description": templeDarshanDetails?.metaDescription,
    "image": templeDarshanDetails?.imageURL || "default-image-url.jpg",
    "author": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com"
      }
    },
    "datePublished": templeDarshanDetails?.publishedDate || null,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": templeDarshanDetails?.CanonicalTag
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": templeDarshanDetails?.metaTitle,
    "description": templeDarshanDetails?.metaDescription,
    "url": templeDarshanDetails?.canonicalURL,
    "image": templeDarshanDetails?.imageURL || "default-image-url.jpg",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": `https://www.myomnamo.com/services/book-puja/${templeDarshanDetails?.templeSlug}`
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.myomnamo.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Temple List",
        "item": "https://www.myomnamo.com/darshan-booking"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": templeDarshanDetails?.metaTitle,
        "item": templeDarshanDetails?.canonicalURL
      }
    ]
  };

  // --------------------------------------

  const plainText = (() => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = templeDarshanDetails.shortDetails;
    return tempDiv.innerText || tempDiv.textContent || "";
  })();

  const toggleReadMore = () => setReadMore(!readMore);
  const toggleDeityReadMore = () => setDeityReadMore(!deityReadMore);
  const toggleReadMoreDetails = () => setReadMoreDetailed(!readMoreDetailed);



  const howItWorks = {
    howItWorksMainHeading: t("Receive Blessings of the Divine"),
    howItWorks: [
      {
        howItWorksTitle: t("Choose Your Temple"),
        howItWorksDesc:
          t("Select your temple and preferred date for darshan. Plan your visit effortlessly, even during peak times."),
      },
      {
        howItWorksTitle: t("Book Your Slot"),
        howItWorksDesc:
          t("Reserve your darshan slot online in minutes. Avoid long queues and secure a peaceful, hassle-free temple experience."),
      },
      {
        howItWorksTitle: t("Get Confirmation"),
        howItWorksDesc:
          t("Receive instant booking confirmation via email or SMS. Show your details at the temple and enjoy your visit stress-free."),
      },
    ],
  }




  return (
    <>
      <Helmet>
        <title>{templeDarshanDetails?.metaTitle}</title>
        <meta name="description" content={templeDarshanDetails?.metaDescription} />
        <link rel="canonical" href={templeDarshanDetails?.canonicalTag} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={templeDarshanDetails?.metaTitle} />
        <meta property="og:description" content={templeDarshanDetails?.metaDescription} />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content={`https://www.myomnamo.com/services/book-puja/${templeDarshanDetails?.templeSlug}`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:locale" content="en_IN" />

        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={templeDarshanDetails?.metaTitle} />
        <meta name="twitter:description" content={templeDarshanDetails?.metaDescription} />
        <meta name="twitter:image" content="" />

        <meta property="og:title" content={templeDarshanDetails?.metaTitle} />
        <meta property="og:description" content={templeDarshanDetails?.metaDescription} />
        <meta property="og:image" content="../public/assets/images/new/fav.png" />
        <meta property="og:url" content="https://www.myomnamo.com/" />
        <meta property="og:type" content="website" />



        {templeDarshanDetails?.extraMetaTag}

        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>
      </Helmet>

      {totalRecords > 0 && (
        <>

          <Container fluid className='pooja-remidy mt-60' style={{ maxWidth: "1200px" }} >


            {/* Main Content Row */}
            <Row className="justify-content-center mt-3">
              {/* Left Column: Image Gallery */}
              <Col md={6}>
                <div className="position-relative d-flex justify-content-center">

                  <Image src={templeDarshanDetails?.image || pandit} style={{ height: `${templeDarshanDetails?.image ? '' : "250px"}` }} className='img-fluid-custom' rounded />



                </div>



                <div className='d-block  d-md-none'>
                  <hr />
                </div>
              </Col>


              {/* Right Column: Puja Details */}
              <Col md={6} className=" mt-md-0">
                <div className=" h-100">
                  {/* Header */}
                  {/* <div className="text-center py-2 seatsLeft">
                                          <p className="mb-0 fw-bold text-muted">Last day today!</p>
                                      </div> */}
                  <div className=" px-md-4">
                    {/* Title and Subtitle */}
                    <h4 className="mb-1 fw-bold">{templeDarshanDetails?.pujaName}</h4>


                    {/* Puja Price  */}

                    <div className="price-tag  position-relative align-items-start mb-1 mt-1">

                      <div className="text-dark px-3  rounded" style={{ background: "#efb423", marginRight: "10px" }}>
                        <strong>
                          ₹{" "}
                          {formatToIndianCurrency(Math.round(templeDarshanDetails.darshanPrice))} /person
                        </strong>


                      </div>

                    </div>



                    {/* Short Description */}
                    {templeDarshanDetails?.shortDetails !== null && templeDarshanDetails?.shortDetails !== undefined && (
                      <p className="small" style={{ marginBottom: "2px" }}>
                        {readMore ? plainText : plainText?.length > maxChars ? `${plainText.substring(0, maxChars)}...` : plainText}
                        {plainText?.length > maxChars && (
                          <span
                            onClick={toggleReadMore}
                            // className="btn-fancy"
                            style={{ color: '#a52444', cursor: 'pointer' }}
                          >
                            {readMore ? t("...Read Less") : t("Read More")}
                          </span>
                        )}
                      </p>
                    )}

                    {templeDarshanDetails?.templeAddress && (
                      <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faLocationDot} size="1x" className="icon-location" />

                        <span className="small location-address">{templeDarshanDetails?.templeAddress}</span>

                      </div>
                    )}












                    {/* Participate Button */}

                    <div className='d-flex justify-content-between'>
                      <Button
                        onClick={() => clickToBook()}

                        size='lg'
                        className="w-50 z-100 rounded-pill  py-1 mt-1 pulse-button  mb-2"
                      >
                        {t("Book Now")}
                      </Button>

                      <div className="d-flex align-items-end gap-2">


                        {/* Share Button */}
                        <Button
                          className="icon-btn share-btn" style={{ height: "45px" }}
                          onClick={() => {
                            if (navigator.share) {
                              navigator.share({
                                title: templeDarshanDetails?.pujaName,
                                text: templeDarshanDetails?.shortDescription || '',
                                url: window.location.href,
                              });
                            } else {
                              alert("Sharing not supported on this device");
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faShareAlt} />
                        </Button>
                      </div>
                    </div>




                  </div>
                </div>
              </Col>
            </Row>



            {/* Tabs Wise Details */}
            <Row>
              <LazySection><DarshanBookingDetailedTabSection templeDarshanDetails={templeDarshanDetails} FAQ={FAQ} t={t} /></LazySection>
            </Row>

            {/* How it Works */}
            <Row>
              <LazySection><HowItWorks serviceData={howItWorks} /></LazySection>
            </Row>

          </Container >
          <LazySection> <DownloadApp languageID={selectedLanguageID == 3 ? 1 : null} /></LazySection>
        </>
      )}




      {totalRecords <= 0 && <NoResultFoundModel totalRecords={totalRecords} />}





      {loginPopUp && (
        <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
      )}
      <ShareLinkModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        shareUrl={currentUrl}
        message={DarshanShareMassage} // Optional
        title="Spread the word" // Optional
      />
    </>
  );
};

export default TempleDetails;
